import Swal from 'sweetalert2'
import { colors } from '../../constants/colors'
import { alertIcons } from '../../assets/icons/icons'
import './swal.stye.css';
import i18n from '../../i18n';

// แปลข้อความภาษาไทยที่ส่งเข้ามา (ข้อความที่แปลแล้วหรือไม่ใช่ภาษาไทยจะคืนค่าเดิม)
const tr = (text?: any) => (typeof text === 'string' && /[฀-๿]/.test(text) ? i18n.t(text.trim()) : text)

type sweetAlertIconType = {
    error: 'error';
    question: 'question',
    info: 'info',
    success: 'success',
    warning: 'warning'
}

export function swalSuccess(title?: string, option?: string, url?: any, callback?: any) {
    Swal.fire({
        icon: 'success',
        title: tr(title),
        confirmButtonColor: colors.themeMainColor
    }).then((value) => {
        if (option === 'reset') {
        } else if (option === 'reload') {
            window.location.reload()
        } else if (option === 'go') {
            window.location.href = url
        } else if (callback != null) {
            value.isConfirmed && callback(true)
        }
    })
}

export const alertSuccess = (title: string, detail?: string, confirmButtonText?: string, callback?: () => void, cancelButtonText?: string) => {
    Swal.fire({
        title: tr(title),
        text: tr(detail),
        confirmButtonColor: colors.complete,
        confirmButtonText: tr(confirmButtonText) || i18n.t('ตกลง'),
        cancelButtonText: tr(cancelButtonText),
        showCancelButton: !!cancelButtonText,
        customClass: {
            popup: 'custom-alert-sweet',
            icon: 'no-border',
            confirmButton: "custom-alert-confirm-button",
            title: "custom-alert-title",
            cancelButton: "custom-alert-cancel-button",
        },
        iconHtml: `<img width={150} height={150} src="${alertIcons.successAlert}" alt="alert-success" />`
    }).then((result) => {
        if (result.isConfirmed) {
            callback && callback();
        }
        return false
    })
}
export const alertError = (title: string, detail?: string, confirmButtonText?: string, callback?: () => void, is_html?: boolean) => {
    Swal.fire({
        title: tr(title),
        ...(is_html ? {
            html: tr(detail)
        } : {
            text: tr(detail)
        }),
        confirmButtonColor: colors.danger,
        confirmButtonText: tr(confirmButtonText) || i18n.t('ตกลง'),
        customClass: {
            popup: 'custom-alert-sweet',
            icon: 'no-border',
            confirmButton: "custom-alert-error-confirm-button",
            title: "custom-alert-title",
        },
        iconHtml: `<img width={150} height={150} src="${alertIcons.errorAlert}" alt="alert-error" />`
    }).then((result) => {
        if (result.isConfirmed) {
            callback && callback();
        }
        return false
    })
}
type ExtraButton = {
    text: string;
    className?: string;
    onClick: () => void;
};

export const alertActive = (
    title: string,
    detail?: string,
    confirmButtonText?: string,
    cancelButtonText?: string,
    callback?: () => void,
    icon?: keyof sweetAlertIconType,
    extraButton?: ExtraButton,
    html?: string
) => {
    Swal.fire({
        title: tr(title),
        icon: icon,
        text: tr(detail),
        html: tr(html),
        cancelButtonText: tr(cancelButtonText) || i18n.t('ยกเลิก'),
        showCancelButton: true,
        confirmButtonColor: colors.complete,
        confirmButtonText: tr(confirmButtonText) || i18n.t('ตกลง'),
        reverseButtons: true,
        customClass: {
            popup: 'custom-alert-sweet',
            icon: 'no-border',
            confirmButton: "custom-alert-active-confirm-button",
            cancelButton: "custom-alert-cancel-button",
            title: "custom-alert-title",
            actions: "custom-alert-actions",
        },
        iconHtml: `<img width="150" height="150" src="${alertIcons.activeAlert}" alt="alert-success" />`,
        footer: extraButton
            ? `<button id="extra-button" class="${extraButton.className || 'extra-btn-default'}">${tr(extraButton.text)}</button>`
            : undefined,
        didOpen: () => {
            if (extraButton) {
                const btn = document.getElementById("extra-button");
                if (btn) {
                    btn.addEventListener("click", () => {
                        Swal.close(); // ปิด alert ถ้าต้องการ
                        extraButton.onClick();
                    });
                }
            }
        }
    }).then((result) => {
        if (result.isConfirmed) {
            callback && callback();
        }
        return false;
    });
};
export function swalError(title?: string, detail?: string) {
    Swal.fire({
        icon: 'error',
        title: tr(title),
        text: tr(detail),
        confirmButtonText: i18n.t('ตกลง'),
        confirmButtonColor: colors.danger
    })
}

export function swalConfirm(title: string, text: string, confirmCallback: () => void, cancelCallback?: () => void) {
    Swal.fire({
        title: tr(title),
        text: tr(text),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: colors.themeMainColor,
        cancelButtonColor: colors.danger,
        confirmButtonText: i18n.t('ตกลง'),
        cancelButtonText: i18n.t('ยกเลิก')
    }).then((result) => {
        if (result.isConfirmed) {
            confirmCallback();
        } else if (cancelCallback) {
            cancelCallback();
        }
    });
}

export function swalActive(title?: string, text?: any, callback?: any, icon?: null | 'info' | 'warning' | 'question', confirmButtonText?: string) {
    Swal.fire({
        title: tr(title),
        // text: text,
        html: tr(text),
        icon: icon || 'success',
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true,
        focusConfirm: false,
        confirmButtonText: tr(confirmButtonText) || i18n.t('ส่งพิจารณา'),
        confirmButtonColor: colors.themeMainColor,
        cancelButtonText: i18n.t('ยกเลิก'),
        customClass: {
            container: 'swal2-warning'
        }
    }).then((confirm) => {
        if (confirm.isConfirmed) {
            return callback(true)
        }
        return;
    })
}

export function swalSuccessAndNavigate(title: string, confirmCallback: () => void, cancelCallback?: () => void) {
    Swal.fire({
        title: tr(title),
        icon: 'success',
        showCancelButton: true,
        confirmButtonColor: colors.themeMainColor,
        cancelButtonColor: colors.themeSecondColor,
        confirmButtonText: i18n.t('ไปที่หน้าตาราง'),
        cancelButtonText: i18n.t('อยู่หน้านี้ต่อ')
    }).then((result) => {
        if (result.isConfirmed) {
            confirmCallback();
        } else if (cancelCallback) {
            cancelCallback();
        }
    });
}